<template>
  <div class="password-step">
    <div class="password-step__heading">
      <div>
        <Heading :level="3"> Digite sua senha </Heading>
        <BaseText
          class="password-step__heading--email"
          size="p5"
          :color="NebraskaColors.elementSecondary"
        >
          {{ form.email }}
        </BaseText>
      </div>
      <div @click="changeToEmailStep">
        <BaseIcon
          class="password-step__heading--icon"
          icon="EE0070"
          width="24px"
          height="24px"
        />
      </div>
    </div>
    <form
      class="password-step__form"
      @submit.prevent="handlePasswordSubmit(password)"
    >
      <InputPassword
        id="password"
        v-model="password"
        class="form-input"
        label="Senha"
        @blur="trackPasswordEvent"
      />
      <div class="form-buttons">
        <ButtonPrimary
          label="Continuar"
          :disabled="disableButton"
          :loading="isLoading"
          size="large"
          data-testid="submit-button"
          type="submit"
        />
        <ButtonSecondary
          type="button"
          label="Esqueci a senha"
          size="large"
          data-testid="forgot-password-button"
          @click="toggleForgotPasswordModal"
        />
      </div>
      <FadeTransition>
        <KeepAlive>
          <ForgotPasswordModal
            v-if="isForgotPasswordModalOpen"
            :is-open="isForgotPasswordModalOpen"
            @close="toggleForgotPasswordModal"
          />
        </KeepAlive>
      </FadeTransition>
    </form>
  </div>
</template>
<script setup lang="ts">
import {
  BaseIcon,
  BaseText,
  ButtonPrimary,
  ButtonSecondary,
  Heading,
  InputPassword
} from '@warrenbrasil/nebraska-web';
import { Ref, computed, inject, onMounted, ref } from 'vue';
import {
  trackForgotPasswordEvent,
  trackPasswordEvent
} from '@/modules/authentication/helpers/track-signin-events';
import ForgotPasswordModal from '@/modules/authentication/views/SignIn/components/ForgotPasswordModal/ForgotPasswordModal.vue';
import { FadeTransition } from '@/modules/common/components/FadeTransition';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { SignInForm } from '@/modules/authentication/views/SignIn/types';

const form = inject('form') as Ref<SignInForm>;
const password = ref<string>('');
const handlePasswordSubmit = inject('handlePasswordSubmit') as (
  password: string
) => void;
const isLoading = inject('isLoading') as Ref<boolean>;
const isForgotPasswordModalOpen = ref<boolean>(false);
const changeToEmailStep = inject('changeToEmailStep') as () => void;

function toggleForgotPasswordModal() {
  !isForgotPasswordModalOpen && trackForgotPasswordEvent();
  isForgotPasswordModalOpen.value = !isForgotPasswordModalOpen.value;
}

const disableButton = computed(() => !password.value);

onMounted(() => {
  document.getElementById('password')?.focus();
});
</script>
<style lang="less" scoped>
.password-step {
  &__heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    &--email {
      max-width: 80vw;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &--icon:hover {
      cursor: pointer;
    }
  }

  &__form {
    margin-top: @size-spacing-x600;
    display: flex;
    flex-direction: column;
    gap: @size-spacing-x600;
  }
}

.form-buttons {
  display: flex;
  justify-content: space-between;
  gap: @size-spacing-x350;

  :deep(.button--container) {
    z-index: 0;
  }

  button {
    width: 226px;
    border-radius: @size-radius-x300;
  }

  @media screen and (max-width: 767px) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
}

:deep(.normal-label) {
  z-index: 0;
}
</style>
